import React from 'react';
import styled from 'styled-components';
import { makeStyles } from "@mui/styles";
import Button from '@mui/material/Button';
import DistanceIcon from "components/CustomIcons/DistanceIcon";
import AreaIcon from "components/CustomIcons/AreaIcon";

const MeasureOptionsList = styled.div`
  position: absolute;
  bottom: 12rem;
  left: 3rem;
`;

const OptionItem = styled.div`
  width: 156px;

  &.border-btn {
    .MuiButtonBase-root {
      border-top-left-radius: 3px !important;
      border-top-right-radius: 3px !important;
    }
  }

  .MuiButton-label {
    .MuiButton-startIcon {
      margin-right: 30px !important;
      margin-left: 0px !important;
    }
  } 
`;

const useStyles = makeStyles((theme) => ({
  button: {
    background: '#1b1b1b !important',
    height: 50,
    borderRadius: '0 !important',
    width: "100%",
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: "13px !important",
    lineHeight: 18,
    color: 'rgba(255, 255, 255, 0.5) !important',
    justifyContent: 'flex-start !important',
    textTransform: 'none !important',

    '&:focus': {
      outline: 'none'
    },

    '&:hover': {
      background: '#2F2F2F !important',
      color: '#e5e5e5 !important'
    }
  },
}));

const MeasureOptions = () => {
  const classes = useStyles();
  return (
    <MeasureOptionsList>
      <OptionItem className="border-btn">
        <Button
          variant="contained"
          className={classes.button}
          startIcon={<DistanceIcon />}
        >
          Distance
        </Button>
      </OptionItem>
      <OptionItem>
        <Button
          variant="contained"
          className={classes.button}
          startIcon={<AreaIcon/>}
        >
          Area
        </Button>
      </OptionItem>      
    </MeasureOptionsList>
  )
}

export default MeasureOptions;
